// Common dropdown menu
// Children as the button to open the menu

import React, { useEffect, useState, useRef } from 'react';

export const MENU_ITEM_STYLE = {
  display: 'grid', 
  gridTemplateColumns: '1.5rem 1fr', 
  padding: '0.5rem 3rem 0.5rem 1.5rem',
  gap: '1rem',
  whiteSpace: 'nowrap',
  alignItems: 'center'
};


// Common DropdownMenu
// Supports both controller and uncontrolled mode. 
// In uncontrolled mode the dropdown is not closed unless cliked outside or toggleOpen called.
// If this should close on item click, use controlled state or make the listItems call toggleOpen
const DropdownMenu = ({
  children,
  menuItems = <></>,
  closeOnOutsideClick = true,
  menuProps = {},
  dropdownStyle = {},
  className = 'dropdown-menu',
  autoPosition = false,
  open: controlledOpen,
  setOpen: setControlledOpen
}) => {
  const wrapperRef = useRef(null);
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? controlledOpen : internalOpen;

  const toggleOpen = (newState) => {
    if (isControlled) {
      setControlledOpen?.(newState);
    } else {
      setInternalOpen(newState);
    }
  };

const onOutsideClick = (event) => {
  const isMetadataClick = !document.body.contains(event.target); // Could be gone from document
  const isInside = wrapperRef.current && wrapperRef.current.contains(event.target);

  if (!isInside && !isMetadataClick) {
    toggleOpen(false);
  }
};

  useEffect(() => {
    if (closeOnOutsideClick) {
      window.addEventListener('click', onOutsideClick);
      return () => {
        window.removeEventListener('click', onOutsideClick);
      };
    }
  }, [closeOnOutsideClick]);

  const { style, rightToLeft, dropup = false, ...rest } = menuProps;
  const dropdownMenuAlign = rightToLeft ? { left: 'auto', right: '0' } : {};

  const handleToggle = (e) => {
    const button = e.currentTarget;
    const wrapper = wrapperRef.current;

    toggleOpen(!isOpen);

    if (autoPosition) {
      requestAnimationFrame(() => {
        const menu = wrapper.querySelector('.dropdown-menu');
        if (!menu) return;

        const buttonRect = button.getBoundingClientRect();
        const menuHeight = menu.offsetHeight || 100;
        const spaceBelow = window.innerHeight - buttonRect.bottom - 60;

        const openUp = spaceBelow < menuHeight;

        if (openUp) {
          menu.style.top = "auto";
          menu.style.bottom = `${wrapper.offsetHeight - button.offsetTop + 8}px`;
        } else {
          menu.style.top = `${button.offsetTop + button.offsetHeight + 8}px`;
          menu.style.bottom = "auto";
        }
      })
    }
  };

  return (
    <span ref={wrapperRef} style={{ position: 'relative', ...style }} {...rest}>
      <span onClick={handleToggle}>
        {children}
      </span>
      {isOpen && (
        <span
          className={className}
          style={{
            position: 'absolute',
            top: dropup ? 'auto' : '100%',
            bottom: dropup ? '100%' : 'auto', // Better dropup handling
            display: 'unset',
            ...dropdownMenuAlign,
            ...dropdownStyle,
          }}
        >
          {/* We pass the toggle function down so menu items can close it */}
          {menuItems && React.cloneElement(menuItems, { setOpen: toggleOpen })}
        </span>
      )}
    </span>
  );
};

export default DropdownMenu;